import React, { Component } from 'react'
import { formatDuration } from '../../../helpers/time.helper'
import './index.sass'

class ProgressBar extends Component {
  state = {
    isMouseDown: false,
  }

  calcClickedTime = e => {
    const { duration } = this.props
    let clickPositionInPage
    if (!e.touches) {
      clickPositionInPage = e.pageX
    } else {
      clickPositionInPage = e.touches[0].pageX
    }
    const bar = this.bar
    const barStart = bar.getBoundingClientRect().left + window.scrollX
    const barWidth = bar.offsetWidth
    const clickPositionInBar = clickPositionInPage - barStart
    const timePerPixel = duration / barWidth
    return timePerPixel * clickPositionInBar
  }

  updateTimeOnMove = eMove => {
    const { onTimeUpdate } = this.props
    onTimeUpdate(this.calcClickedTime(eMove))
  }

  updateIsMouseDown = eMove => {
    this.setState({isMouseDown: !this.state.isMouseDown})
    this.updateTimeOnMove(eMove)
  }

  updateIsMouseUp = eMove => {
    this.setState({isMouseDown: false})
    this.updateTimeOnMove(eMove)
  }

  onMouseLeave = () => {
    this.setState({isMouseDown: false})
  }

  handleTimeDrag = eMove => {
    if (!this.state.isMouseDown) {
      return
    } else {
      this.updateTimeOnMove(eMove)
    }
    
  }

  render = () => {
    const { currentTime, duration, isPlaying } = this.props
    const curPercentage = (currentTime / duration) * 100
    return (
      <div className='progress-bar-wrapper'>
        <div
          className="progress-bar"
          style={{
            background: `linear-gradient(to right, #75d2cc ${curPercentage}%, #000000 0)`,
          }}
          ref={ref => (this.bar = ref)}
          onMouseUp={this.updateIsMouseUp}
          onMouseDown={this.updateIsMouseDown}
          onMouseMove={this.handleTimeDrag}
          onTouchMove={this.updateTimeOnMove}
          onMouseLeave={this.onMouseLeave}
        ></div>
        <span
          className={
            !isPlaying && !currentTime ? 'caption current-time stop' : 'caption current-time'
          }
        >
          {formatDuration(currentTime || 0)}
        </span>
        <span className={!isPlaying && !currentTime ? 'caption duration stop' : 'caption duration'}>
          {formatDuration(duration || 0)}
        </span>
      </div>
    )
  }
}

export default ProgressBar
